import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-fluid h-100 p-0" }
const _hoisted_2 = { class: "row h-100 g-0" }
const _hoisted_3 = { class: "col-12 col-md-3 col-lg-3 h-100" }
const _hoisted_4 = {
  class: "overflow-y-auto h-100 pt-4 px-3",
  style: {"height":"calc(100vh - 60px)"}
}
const _hoisted_5 = { class: "mb-3 pb-3 border-bottom" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "form-label" }
const _hoisted_9 = { value: "" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "mb-3 pb-3 border-bottom" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_14 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_15 = { class: "visually-hidden" }
const _hoisted_16 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = { class: "form-label" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { value: "" }
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = { class: "form-label" }
const _hoisted_25 = ["onUpdate:modelValue"]
const _hoisted_26 = { class: "mb-3 pb-3" }
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = {
  key: 0,
  class: "text-center py-3"
}
const _hoisted_29 = {
  class: "spinner-border text-primary",
  role: "status"
}
const _hoisted_30 = { class: "visually-hidden" }
const _hoisted_31 = {
  key: 1,
  class: "alert alert-danger"
}
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "mb-3" }
const _hoisted_34 = { class: "form-label" }
const _hoisted_35 = ["onUpdate:modelValue"]
const _hoisted_36 = { value: "" }
const _hoisted_37 = ["value"]
const _hoisted_38 = { class: "mb-3" }
const _hoisted_39 = { class: "form-label" }
const _hoisted_40 = ["onUpdate:modelValue"]
const _hoisted_41 = { class: "col-12 col-md-9 col-lg-9 h-100 d-none d-md-block p-4" }
const _hoisted_42 = {
  class: "position-fixed h-100 drawing-component-container",
  style: {"top":"90px","left":"33%","right":"10px"}
}
const _hoisted_43 = {
  class: "col-12 d-md-none p-4",
  style: {"height":"250px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DrawingComponent = _resolveComponent("DrawingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("section", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.kitConfiguration")), 1),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.selectKit")), 1),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedKit) = $event)),
                class: "form-select",
                onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleKitSelection && _ctx.handleKitSelection(...args)))
              }, [
                _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.customize")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableKits, (kit) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: kit.id,
                    value: kit.id
                  }, _toDisplayString(kit.name), 9, _hoisted_10))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.selectedKit]
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_11, [
            _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.panelConfiguration")), 1),
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.loading")), 1)
                  ])
                ]))
              : (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.error), 1))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.panels, (panel, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'panel-' + index,
                      class: "panel-config position-relative"
                    }, [
                      (_ctx.panels.length > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.removePanel(index)),
                            class: "btn btn-close position-absolute",
                            style: {"right":"10px","top":"10px"},
                            "aria-label": "Delete panel"
                          }, null, 8, _hoisted_17))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.panelModel")), 1),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((panel.device_id) = $event),
                          class: "form-select"
                        }, [
                          _createElementVNode("option", _hoisted_21, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.selectModel")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipmentStore.panels, (panelModel) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: panelModel.id,
                              value: panelModel.id
                            }, _toDisplayString(panelModel.manufacturer) + " " + _toDisplayString(panelModel.model_number), 9, _hoisted_22))
                          }), 128))
                        ], 8, _hoisted_20), [
                          [_vModelSelect, panel.device_id]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.numberOfPanels")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((panel.pcs) = $event),
                          class: "form-control",
                          min: "1"
                        }, null, 8, _hoisted_25), [
                          [_vModelText, panel.pcs]
                        ])
                      ]),
                      false
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addPanel && _ctx.addPanel(...args))),
                            class: "btn btn-outline-primary btn-sm"
                          }, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.addAnotherPanel")), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
          ]),
          _createElementVNode("section", _hoisted_26, [
            _createElementVNode("h3", _hoisted_27, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.inverterConfiguration")), 1),
            (_ctx.isLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.loading")), 1)
                  ])
                ]))
              : (_ctx.error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(_ctx.error), 1))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.inverters, (inverter, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: 'inverter-' + index,
                      class: "inverter-config position-relative"
                    }, [
                      (_ctx.inverters.length > 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.removeInverter(index)),
                            class: "btn btn-close position-absolute",
                            style: {"right":"10px","top":"10px"},
                            "aria-label": "Delete inverter"
                          }, null, 8, _hoisted_32))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_33, [
                        _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.inverterModel")), 1),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": ($event: any) => ((inverter.device_id) = $event),
                          class: "form-select"
                        }, [
                          _createElementVNode("option", _hoisted_36, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.selectModel")), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.equipmentStore.inverters, (inv) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: inv.id,
                              value: inv.id
                            }, _toDisplayString(inv.manufacturer) + " " + _toDisplayString(inv.model_number), 9, _hoisted_37))
                          }), 128))
                        ], 8, _hoisted_35), [
                          [_vModelSelect, inverter.device_id]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("project.panelsPositioningComponent.numberOfUnits")), 1),
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          "onUpdate:modelValue": ($event: any) => ((inverter.pcs) = $event),
                          class: "form-control",
                          min: "1"
                        }, null, 8, _hoisted_40), [
                          [_vModelText, inverter.pcs]
                        ])
                      ]),
                      (index === _ctx.inverters.length - 1)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addInverter && _ctx.addInverter(...args))),
                            class: "btn btn-outline-primary btn-sm"
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.$t("project.panelsPositioningComponent.addAnotherInverter")) + " ", 1),
                            _cache[4] || (_cache[4] = _createElementVNode("i", { class: "bi bi-plus ms-2" }, null, -1))
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createVNode(_component_DrawingComponent, {
            class: "h-85",
            "selected-panel-model": _ctx.selectedPanelModel,
            "total-panels": _ctx.totalPanels,
            "onUpdate:drawingData": _ctx.handleDrawingDataUpdate
          }, null, 8, ["selected-panel-model", "total-panels", "onUpdate:drawingData"])
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createVNode(_component_DrawingComponent, {
          "selected-panel-model": _ctx.selectedPanelModel,
          "onUpdate:drawingData": _ctx.handleDrawingDataUpdate
        }, null, 8, ["selected-panel-model", "onUpdate:drawingData"])
      ])
    ])
  ]))
}